/**
 * Note-generation lifecycle vocabulary (`StreamingStatus`).
 *
 * History: extracted from `scribeRecordModel.ts` into a `src/models` leaf to
 * break the circular-import risk called out in
 * `docs/design-docs/stream-response-refactor.md` §11 R1, then moved here with
 * the session type closure (OpenSpec `monorepo-session-data-core` C2) — it is
 * the one record-model rider the data core takes (design D2a), because
 * `QuerySessionResponse.streamingStatus` and the editor's note-persistence
 * seam both speak this vocabulary. The `src/models` leaf is gone and its
 * importers read this door directly; `@/models/scribeRecordModel` still
 * re-exports the enum for its own legacy consumers.
 */
export enum StreamingStatus {
  NOT_STARTED = 'NOT_STARTED',
  AWAITING_STREAMING_START = 'AWAITING_STREAMING_START',
  STREAMING = 'STREAMING',
  UPLOADING = 'UPLOADING',
  FINISHING_STREAMING = 'FINISHING_STREAMING',
  MANUALLY_ABORTED = 'MANUALLY_ABORTED',
  CONVERTING_SECTIONAL_NOTES = 'CONVERTING_SECTIONAL_NOTES',
  GENERATION_FAILED = 'GENERATION_FAILED',
}
